<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'samplemanage-sampleStockCheck',
  components: {
    PageTable,
  },
}
</script>
